/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

const GeoMapCellContent = ({
  geographyData,
  handleMouseUp,
  selectedRows,
  index,
  style,
  selectedTab,
  getGeoTitle,
 }) => {
  const [geoTitle, setGeoTitle] = useState('');
  const getGeographyTitle = (geoName, pid, selectedTab) => {
    const geographyTitle = getGeoTitle(geoName, pid, selectedTab);
    setGeoTitle(geographyTitle);
  };

  return (
    <div
      style={
        selectedRows.indexOf(geographyData[index].pid) !== -1
          ? { background: '#EEEEEE', color: '#30435d', ...style }
          : { ...style }
      }
      className="geo-grid-row-content"
      data-test="geomapDataGrid"
      onMouseUp={e => handleMouseUp(
        e, geographyData[index].pid, geographyData.map(i => i.pid),
        geographyData[index].sp)}
    >
      <Fragment>
        <div data-test="geomapcellcontentcomponent" className="geo-grid-cell-item-0">
          <div
            className='geo-grid-cell-item-value'
            onMouseOver={() => getGeographyTitle(geographyData[index].g,
              geographyData[index].pid, selectedTab)}
              onFocus={ () => {} }
          >{`${geographyData[index].g}`}
            <span id="tooltip-text" className="tooltip-text">{geoTitle}</span>
          </div>
        </div>
        <div data-test="geomapcellcontentcomponent" className="geo-grid-cell-item">
          <div
            className='geo-grid-cell-item-value'
          >
            {`${geographyData[index].ts}`}
          </div>
        </div>
        <div data-test="geomapcellcontentcomponent" className="geo-grid-cell-item">
          <div
            className='geo-grid-cell-item-value'
          >
            {`${geographyData[index].tw}`}
          </div>
        </div>
        <div data-test="geomapcellcontentcomponent" className="geo-grid-cell-item">
          <div
            className='geo-grid-cell-item-value'
          >
            {`${geographyData[index].bw}`}
          </div>
        </div>
        <div data-test="geomapcellcontentcomponent" className="geo-grid-cell-item">
          <div
            className='geo-grid-cell-item-value'
          >
            {`${geographyData[index].h}%`}
          </div>
        </div>
        <div data-test="geomapcellcontentcomponent" className="geo-grid-cell-item-5">
          <div
            className='geo-grid-cell-item-value'
          >
            {`${geographyData[index].i}`}
          </div>
        </div>
      </Fragment>
      <input
        type="checkbox"
        className="geo-grid-row-content-checkbox"
        name={geographyData[index].g}
        checked={selectedRows.includes(geographyData[index].pid)}
        id={`${geographyData[index].pid}-checkbox-${geographyData[index].g}`}
        onChange={() => {}}
      />
      <label
        style={
          selectedRows.indexOf(geographyData[index].pid) !== -1
            ? { display: 'block' }
            : {}
        }
        htmlFor={`${geographyData[index].pid}-checkbox-${geographyData[index].g}`}
      />
    </div>
  );
};

GeoMapCellContent.propTypes = {
  index: PropTypes.number,
  style: PropTypes.shape({}),
  geographyData: PropTypes.instanceOf(Array),
  handleMouseUp: PropTypes.func,
  selectedRows: PropTypes.instanceOf(Array),
  getGeoTitle: PropTypes.func,
  selectedTab: PropTypes.string,
};

export default GeoMapCellContent;
